import {Injectable} from '@angular/core';
import {CsvHandler} from "./csv-handler";

@Injectable({
    providedIn: 'root'
})
export class CsvExporterService {
    private csv: CsvHandler;

    constructor() {
    }

    generate(DataJSON: any, filename: string, options?: Object) {
        this.csv = new CsvHandler(DataJSON, filename, options);
    }
}
